export default __webpack_public_path__ + "static/media/healthBenefitBanner.eeca1c81.png";